import { FC, useMemo } from 'react';

import { Box, Typography } from '@mui/material';

import ReusableGrid from 'src/components/ReusableGrid';
import SubNavigation, { Step } from 'src/components/SubNavigation/SubNavigation';
import { DEFAULT_BORDER } from 'src/constants';
import { Principal } from 'src/types/AddMerchant/merchantInfo';
import buildContact from 'src/utils/buildContact';

interface ContactMapSectionProps {
    principals: Principal[];
    height: number | string;
}

const ContactMapSection: FC<ContactMapSectionProps> = ({ principals, height }) => {
    const contactInformation = useMemo(() => {
        return buildContact(principals);
    }, [principals]);
    const steps: Step[] = contactInformation.map((_c, i) => {
        return {
            label: `Principal ${i + 1}`,
            step: `principal${i + 1}`,
        };
    });

    return (
        <Box flex="0 0 73%" height={height}>
            <ReusableGrid title="Contact Information" xs={12} enableContainer>
                <Box display="flex" gap={2} height="100%" px={3} pb={3}>
                    {/* left – contact list */}
                    <Box flex="0 0 50%" sx={{ '& .MuiMenuList-root': { display: 'none' } }}>
                        <SubNavigation steps={steps} contactInformation={contactInformation} />
                    </Box>

                    {/* right – map placeholder */}
                    <Box
                        flex="1"
                        sx={{
                            ...DEFAULT_BORDER,
                            bgcolor: '#F5F5F5',
                            borderRadius: 1,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <Typography variant="subtitle1" color="text.secondary">
                            Geo Map (coming soon)
                        </Typography>
                    </Box>
                </Box>
            </ReusableGrid>
        </Box>
    );
};

export default ContactMapSection;
